import { ChangeDetectorRef, Component, DoCheck, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ToggleService } from './toggle.service';
import { DatePipe, Location } from '@angular/common';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { GestorDialogComponent } from '../../gestor/gestor-dialog/gestor-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TemaService } from 'src/app/services/tema.services';
import { Subscription } from 'rxjs';
import { SseService } from 'src/app/services/SseService';
import { SuscripcionesService } from "src/app/services/suscripciones.service";
import { SuscripcionesComponent } from "../../suscripciones/suscripciones.component";
import { InformeComponent } from "../../informe/informe.component";
import { GestionListasComponent } from "../../gestion-listas/gestion-listas.component";
import { GestionService } from 'src/app/services/gestion.services';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { LoginDialogComponent } from '../../broker/login-dialog/login-dialog.component';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { UpdateToastComponent, VERSION_UPDATE_SNOOZE_KEY } from '../update-toast/update-toast.component';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { Notificacion } from 'src/app/models/notificacion';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { NotificacionDetalleDialogComponent } from '../notificacion-detalle-dialog/notificacion-detalle-dialog.component';
import { ibrkServices } from 'src/app/services/ibrk.service';
import { BrokerService } from 'src/app/services/broker.services';
import { OAuthService } from 'src/app/services/oauth.service';
import { MetaApiService, META_API_ACCOUNT_KEY, METAAPI_REGIONES } from 'src/app/services/meta-api.service';
import { global } from 'src/app/global';
import { VersionCheckService } from '../../../services/version-check.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { BrokerTabLockService } from 'src/app/services/broker-tab-lock.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentVersion = global.currentVersion;
  private updateToastRef?: ActiveToast<any>;
  // Opciones de routerLinkActive: marcar el botón según el path e IGNORAR los query
  // params (p. ej. /portfolio-labs?idcarteraoptima=...&idcartera=...) y el fragment.
  readonly rlaExact = { paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' } as const;
  readonly rlaSubset = { paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' } as const;
  // Planificador y Screener comparten /models y sólo se distinguen por ?modo=analisis, así que
  // routerLinkActive (que ignora los query params) marcaría los dos: se resuelve a mano.
  get enScreener(): boolean {
    const url = this.router.url;
    const path = url.split(/[?#]/)[0];
    return (path === '/models' || path.startsWith('/models/')) && /[?&]modo=analisis(&|#|$)/.test(url);
  }
  get enPlanificador(): boolean {
    const path = this.router.url.split(/[?#]/)[0];
    return (path === '/models' || path.startsWith('/models/')) && !this.enScreener;
  }
  isSticky: boolean = false;
  rutagestor='';
  rutamodel = '';
  public isGestorSubscribed: boolean = false;
public isBrokerSubscribed: boolean = false;
  public id = 'isBroker';
  public islogin: boolean;
  usernameglobal = '';
  isAdmin: boolean = false;
  public subTheme: Subscription;
  public subLogin: Subscription;
  subGestOptima: any;
  subBrokOptima: Subscription;
  optimalWallet: OptimalWallet;
  public BrokoptimalWallet: OptimalWallet;
  public brokerTipoBroker: string = localStorage.getItem('brokerTipoBroker') || '';
  public brokerConectado: boolean = localStorage.getItem('brokerConectado') === 'true';
  public meta_api_account_login: string = localStorage.getItem('meta_api_account_login') || '';
  public ultima_cuenta_broker: string = localStorage.getItem('ultima_cuenta_broker') || '';
  public metaApiRegiones = METAAPI_REGIONES;
  public metaApiRegion: string = '';
  private subRegion: Subscription;
  private storageListener: (e: StorageEvent) => void;
  private visibilityChangeHandler: () => void;
  private connectionCheckInterval: any;
  public brokerVerificando: boolean = false;
  theme: string;
  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scrollPosition >= 50) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }

  isToggled = false;
  isDark: boolean = false;

  screenHeight: number = innerHeight;
  screenWidth: number = innerWidth;
  userId = 0;
  listaNotificaciones: Notificacion[] = [];
  totalNotificacionesPendientes: number = 0;
  private timerSubscription: Subscription;
  public notificacion: string = ''; // Add this if you need to display notification text in template

  constructor(private versionCheckService: VersionCheckService,
    // snackBar removed; using ToastrService
    public router: Router,
    private location: Location,
    private toggleService: ToggleService,
    private datePipe: DatePipe,
    public themeService: CustomizerSettingsService,
    private cookieService: CookieService,
    public dialog: MatDialog,
    public temaservicio: TemaService,
    private _sseService: SseService,
    private _gestionsv: GestionService,
    private notificacionService: NotificacionService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private _ibrkService: ibrkServices,
    private _brokersv: BrokerService,
    private oauthService: OAuthService,
    private metaApiService: MetaApiService,
    private brokerTabLock: BrokerTabLockService
  ) {
    this.toggleService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
    window.onresize = (e) => {
      this.screenHeight = window.innerHeight;
      this.screenWidth = window.innerWidth;
    }

  }
  toggleGestorSubscription(event: MatCheckboxChange) {
    this.isGestorSubscribed = event.checked;
    // Aquí puedes agregar la lógica para suscribirse/desuscribirse del gestor
    console.log('Gestor subscription:', this.isGestorSubscribed);
  }
  
  toggleBrokerSubscription(event: MatCheckboxChange) {
    this.isBrokerSubscribed = event.checked;
    // Aquí puedes agregar la lógica para suscribirse/desuscribirse del broker
    console.log('Broker subscription:', this.isBrokerSubscribed);
  }
  
  checkForNewVersion() {
    this.versionCheckService.getLatestVersion().subscribe(
      (latestVersion) => {
        //let version = JSON.parse(latestVersion.toString());
        console.log('Latest version:', latestVersion.version);
        console.log('Current version:', this.currentVersion);
        // Avisa a las pestañas con código antiguo (p. ej. antes de activar la sesión única en el backend)
        if (latestVersion?.version && latestVersion.version !== this.currentVersion && !this.isUpdateSnoozed()) {
          this.showUpdateNotification();
        }
      },

    );
  }
  private isUpdateSnoozed(): boolean {
    try {
      const until = Number(localStorage.getItem(VERSION_UPDATE_SNOOZE_KEY));
      return !!until && Date.now() < until;
    } catch {
      return false;
    }
  }
  showUpdateNotification() {
    // Solo un aviso visible a la vez; la recarga solo ocurre con el botón "Actualizar ahora"
    if (this.updateToastRef) return;
    this.updateToastRef = this.toastr.show('Hay una nueva versión disponible. Guarda tu trabajo antes de actualizar.', 'Nueva versión disponible', {
      toastComponent: UpdateToastComponent,
      disableTimeOut: true,
      tapToDismiss: false,
      closeButton: false,
      progressBar: false,
      toastClass: 'ngx-toastr snackbar-update-bg'
    });
    this.updateToastRef?.onHidden.subscribe(() => {
      this.updateToastRef = undefined;
    });
  }
  isRouteActive(route: string): boolean {
    return this.router.isActive(route, true);
  }
  updateActiveRoute() {
    this.rutagestor = this.isRouteActive('/gestor') ? 'active' : '';
    this.rutamodel = this.isRouteActive('/models') ? 'active' : '';
    //console.log("Ruta gestor:", this.rutagestor);
    //console.log("Ruta models:", this.rutamodel);
  }
  ngOnInit(): void {
   // this.updateActiveRoute();
 // this.router.events.subscribe(() => {
   // this.updateActiveRoute();
 // });
    this.checkForNewVersion();
    this.consultarNotificaciones();
    this.subTheme = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });
    this.subLogin = this._sseService.valIsLogin$.subscribe({
      next: (data: any) => {
        if (data) {
          this.islogin = data;
          this.usernameglobal = this.cookieService.get('username_logged');
          this.isAdmin = this.cookieService.get('user_type_id') === '1';
          console.log("Correo al iniciar sesion this.usernameglobal ", this.usernameglobal);
        } else {
          this.islogin = this.cookieService.check('auth_token');
          this.isAdmin = this.cookieService.get('user_type_id') === '1';
        }

      }
    });
    this.subGestOptima = this._gestionsv.valgestOptimaWallet$.subscribe({
      next: (data: any) => {
        this.optimalWallet = data;
        console.log("HEADER OPTIMA", data);
      }
    });
    this.subBrokOptima = this._brokersv.valBrokOptimaWallet$.subscribe({
      next: (data: any) => {
        this.BrokoptimalWallet = data;
        // brokerTipoBroker is synced via the storage event listener (same-tab and cross-tab)
        // to avoid the initial BehaviorSubject emission overwriting the persisted localStorage value
      },
    });
    this.subRegion = this.metaApiService.region$.subscribe(region => {
      this.metaApiRegion = region;
      this.cd.markForCheck();
    });
    this.storageListener = (e: StorageEvent) => {
      if (e.key === 'brokerTipoBroker' || e.key === 'brokerConectado') {
        this.ngZone.run(() => {
          if (e.key === 'brokerTipoBroker') {
            this.brokerTipoBroker = e.newValue || '';
          } else {
            this.brokerConectado = e.newValue === 'true';
          }
        });
      }
    };
    window.addEventListener('storage', this.storageListener);

    this.visibilityChangeHandler = () => {
      if (document.hidden) return;
      // Re-sync broker state from localStorage after PC wake-up / tab focus
      this.ngZone.run(() => {
        this.brokerVerificando = true;
        this.brokerTipoBroker = localStorage.getItem('brokerTipoBroker') || '';
        this.meta_api_account_login = localStorage.getItem('meta_api_account_login') || '';
        this.ultima_cuenta_broker = localStorage.getItem('ultima_cuenta_broker') || '';
        const storedConectado = localStorage.getItem('brokerConectado') === 'true';
        if (storedConectado && this.brokerTipoBroker === 'IBKR' && !this.cookieService.check('auth_broker')) {
          // IBKR session cookie expired while suspended — mark as disconnected
          localStorage.setItem('brokerConectado', 'false');
          window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
          this.brokerConectado = false;
        } else {
          this.brokerConectado = storedConectado;
        }
        this.brokerVerificando = false;
        this.cd.markForCheck();
      });
    };
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);

    this.timerSubscription = this.notificacionService.timerNotification$.subscribe(
      notification => {
        if (notification.message) {
          // Handle the notification display logic here
          // You can use your existing notification system or create a new one
          this.showNotification(notification.message, notification.title);
        }
      }
    );

    this.connectionCheckInterval = setInterval(() => this.verificarConexionPeriodica(), 10000);

    // Auto-detectar credenciales MetaAPI al arrancar aunque no se haya pasado por el flujo completo del broker
    if (!this.brokerConectado) {
      const metaToken = this.metaApiService.getToken();
      const metaAccountId = this.metaApiService.getAccountId();
      if (metaToken && metaAccountId) {
        this.metaApiService.verifyConnection(metaAccountId).subscribe({
          next: (ok: boolean) => {
            if (ok) {
              this.ngZone.run(() => {
                this.brokerConectado = true;
                this.brokerTipoBroker = 'METAAPI';
                localStorage.setItem('brokerConectado', 'true');
                localStorage.setItem('brokerTipoBroker', 'METAAPI');
                window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'true' }));
                window.dispatchEvent(new StorageEvent('storage', { key: 'brokerTipoBroker', newValue: 'METAAPI' }));
                if (!this.meta_api_account_login) {
                  this.metaApiService.getAccountInformationShared(metaAccountId).subscribe({
                    next: (info: any) => {
                      if (info?.login) {
                        this.meta_api_account_login = String(info.login);
                        localStorage.setItem('meta_api_account_login', this.meta_api_account_login);
                      }
                      this.cd.markForCheck();
                    }
                  });
                } else {
                  this.cd.markForCheck();
                }
              });
            }
          }
        });
      }
    }
  }
  ngOnDestroy(): void {
    this.subTheme.unsubscribe();
    this.subLogin.unsubscribe();
    this.subRegion?.unsubscribe();
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    if (this.storageListener) {
      window.removeEventListener('storage', this.storageListener);
    }
    if (this.visibilityChangeHandler) {
      document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    }
    if (this.connectionCheckInterval) {
      clearInterval(this.connectionCheckInterval);
    }
  }

  /** Keeps the region selector reachable while disconnected, so a failing region can be swapped. */
  get metaApiConCredenciales(): boolean {
    return this.metaApiService.hasToken() && !!this.metaApiService.getAccountId();
  }

  /** Account served by the local Nectum MT5 Gateway: there is no MetaAPI region to pick. */
  get metaApiGateway(): boolean {
    return this.metaApiService.isGateway();
  }

  /** Switches the MetaAPI client API to another region and re-checks the connection right away. */
  cambiarRegionMetaApi(region: string): void {
    if (!region || region === this.metaApiRegion) return;
    this.metaApiService.setRegionManual(region);
    const accountId = this.metaApiService.getAccountId();
    if (!accountId) return;
    this.brokerVerificando = true;
    // maxAgeMs 0: skip the cross-tab cache, it holds the answer from the previous region
    this.metaApiService.verifyConnection(accountId, 0).subscribe({
      next: (ok: boolean) => {
        this.brokerVerificando = false;
        this.brokerConectado = ok;
        localStorage.setItem('brokerConectado', String(ok));
        window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: String(ok) }));
        if (!ok) {
          this.toastr.warning(`La cuenta no responde en la región ${region}.`, 'MetaAPI', { timeOut: 6000 });
        }
        this.cd.markForCheck();
      },
      error: () => {
        this.brokerVerificando = false;
        this.cd.markForCheck();
      }
    });
  }

  private verificarConexionPeriodica(): void {
    // Con credenciales MetaAPI se sigue comprobando aunque esté desconectado, para reconectar solo
    const metaApiConCredenciales = this.brokerTipoBroker === 'METAAPI'
      && !!this.metaApiService.getToken()
      && !!localStorage.getItem(META_API_ACCOUNT_KEY);
    if (!this.brokerConectado && !metaApiConCredenciales) return;
    // El componente /broker ya tiene su propio polling cada 5 s; no duplicar
    if (this.router.isActive('/broker', false)) return;

    this.ngZone.run(() => {
      if (this.brokerTipoBroker === 'METAAPI') {
        const accountId = localStorage.getItem(META_API_ACCOUNT_KEY) || '';
        if (!accountId) {
          this.brokerConectado = false;
          localStorage.setItem('brokerConectado', 'false');
          window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
          return;
        }
        this.metaApiService.verifyConnection(accountId).subscribe({
          next: (ok: boolean) => {
            if (ok === this.brokerConectado) return;
            this.brokerConectado = ok;
            localStorage.setItem('brokerConectado', String(ok));
            window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: String(ok) }));
            this.cd.markForCheck();
          },
          error: () => {
            this.brokerConectado = false;
            localStorage.setItem('brokerConectado', 'false');
            window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
            this.cd.markForCheck();
          }
        });
      } else if (this.brokerTipoBroker === 'IBKR') {
        this.oauthService.apiGetIbrk('/iserver/auth/status').subscribe({
          next: (data: any) => {
            const ok = data?.authenticated === true && data?.connected === true && data?.competing === false;
            if (!ok) {
              this.cookieService.delete('auth_broker');
              this.brokerConectado = false;
              localStorage.setItem('brokerConectado', 'false');
              window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
              this.cd.markForCheck();
            }
          },
          error: () => {
            this.cookieService.delete('auth_broker');
            this.brokerConectado = false;
            localStorage.setItem('brokerConectado', 'false');
            window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
            this.cd.markForCheck();
          }
        });
      }
    });
  }
  ngAfterViewInit(): void {
    if (this.usernameglobal == '') {
      setTimeout(() => {
        this.usernameglobal = this.cookieService.get('username_logged');
        console.log("usernameglobal: ", this.usernameglobal);
      }, 2000);
    }
  }


  openDialog(): void {
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(GestorDialogComponent, {
      width: '800px',
      height: '580px',
      panelClass: dialogClass
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
    });
  }

  abrirDialogoInicioSesion() {
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '800px', // Ancho del diálogo
      height: '600px', // Altura del diálogo
      panelClass: dialogClass,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialogo cerrado', result);
      // Aquí puedes realizar acciones después de que el diálogo se cierre
    });
  }

  toggleTheme(event?: any) {
    const newValue = event !== undefined ? event.checked : !this.isDark;
    this.temaservicio.toggleTheme(newValue);
  }

  toggle() {
    this.toggleService.toggle();
  }

  toggleSidebarTheme() {
    this.themeService.toggleSidebarTheme();
  }

  toggleHideSidebarTheme() {
    this.themeService.toggleHideSidebarTheme();
  }

  toggleCardBorderTheme() {
    this.themeService.toggleCardBorderTheme();
  }

  toggleHeaderTheme() {
    this.themeService.toggleHeaderTheme();
  }

  toggleCardBorderRadiusTheme() {
    this.themeService.toggleCardBorderRadiusTheme();
  }

  toggleRTLEnabledTheme() {
    this.themeService.toggleRTLEnabledTheme();
  }

  verSuscripciones() {
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    this.dialog.open(SuscripcionesComponent, {
      width: "95%",
      maxWidth: "95vw",
      height: "80%",
      panelClass: dialogClass
    });
  }

  guardarNotificacion(notificacion: Notificacion) {
    notificacion.estado = true;
    this.notificacionService.guardarNotificacion(notificacion).subscribe({
      next: (value) => {
        //this.cd.markForCheck();
      },
      error: (err) => {
        this.toastr.error("Ocurrió un error actualizando la notificación");
      },
    });
  }

  verDetalleNotificacion(notificacion: Notificacion) {
    this.dialog.open(NotificacionDetalleDialogComponent, {
      data: notificacion,
      panelClass: this.isDark ? 'dark-theme' : 'light-theme',
    });
  }

  obtenerClaseIndicadorNotificaciones() {
    return this.totalNotificacionesPendientes > 0
      ? "btn p-0 border-none rounded-circle position-relative notification-btn"
      : "btn p-0 border-none rounded-circle position-relative";
  }

  consultarNotificaciones() {
    this.userId = Number(
      this.cookieService.get("userId") ? this.cookieService.get("userId") : 0
    );
    if (this.userId) {
      this.notificacionService
        .listarNotificacionesPorUsuario(this.userId)
        .subscribe({
          next: (value) => {
            this.listaNotificaciones = value;
            this.totalNotificacionesPendientes = value.length;
            this.cd.markForCheck();
          },
          error: (err) => {
            this.toastr.error("Ocurrió un error consultando suscripciones");
          },
        });
    }
  }

  verinforme() {
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    this.dialog.open(InformeComponent, {
      width: "90%",
      height: "90%",
      data: { originalTheme: dialogClass, style: dialogClass },
      //panelClass: dialogClass
    });
  }

  gestionarlistas() {
    /**const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    this.dialog.open(GestionListasComponent, {
      width: "90%",
      height: "70%",
      panelClass: dialogClass
    });**/
    // abrir el componente de gestion de listas en una nueva pestaña respetando el base href actual
    const urlTree = this.router.createUrlTree(['/listas']);
    const relativeUrl = this.router.serializeUrl(urlTree);
    const externalUrl = this.location.prepareExternalUrl(relativeUrl);
    const fullUrl = new URL(externalUrl, window.location.origin).toString();
    window.open(fullUrl, '_blank');
  }

  botonSesionBroker() {
    if (this.brokerConectado) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.isDark ? 'dark-theme' : 'light-theme',
        data: { msj: 'Esta Seguro de Cerrar Sesion en Broker? \n Debera volver a ingresar sus credenciales.' }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (this.brokerTipoBroker === 'METAAPI') {
            this.metaApiService.clearCredentials();
            localStorage.setItem('brokerConectado', 'false');
            window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
            // BrokerTabGuard rechaza la navegación si /broker está abierto en otra pestaña
            this.router.navigate(['/broker']);
            return;
          }
          this.oauthService.apiGetIbrk('/logout').subscribe({
            next: (data: any) => {
              if (data.status) {
                this.cookieService.delete('auth_broker');
                this.cookieService.delete('liveSessionToken');
                this.cookieService.delete('accessToken');
                this.cookieService.delete('diffieHellmanChallenge');
                this.cookieService.delete('oauthToken');
                this.cookieService.delete('oauthVerifier');
                this.cookieService.delete('prepend');
                this.cookieService.delete('tokenSecret');
                localStorage.setItem('brokerConectado', 'false');
                window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
                // BrokerTabGuard rechaza la navegación si /broker está abierto en otra pestaña
                this.router.navigate(['/broker']);
              }
            }
          });
        }
      });
    } else {
      // El login abre /broker?cuenta=…: no iniciarlo si /broker ya vive en otra pestaña
      this.brokerTabLock.isHeldElsewhere().then(enOtra => {
        if (enOtra) {
          this.toastr.error('El broker ya está abierto en otra pestaña', 'Broker', { timeOut: 4000 });
          return;
        }
        this.abrirLoginBroker();
      });
    }
  }

  private abrirLoginBroker() {
    if (this.brokerTipoBroker === 'METAAPI') {
      localStorage.setItem('iboauthmethod', '2');
    }
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    this.dialog.open(LoginDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: dialogClass,
      data: { modo: 'dev', cuenta: undefined }
    });
  }

  async checkActive(component: any) {

    if (component == 'gestor') {
      const isActive = this.router.isActive('/gestor', true);
      console.log("ESTA ACTIVO EL LINK: ", isActive);
      console.log("Object.keys(this.optimalWallet).length > 0 ", Object.keys(this.optimalWallet).length > 0)
      if (isActive) {
        this.openDialog();
        console.log("SE BARE EL DIALOG");
      } else if (!isActive && Object.keys(this.optimalWallet).length > 0) {
        this.router.navigate(['/gestor']);
      } else if (!isActive && Object.keys(this.optimalWallet).length <= 0) {
        console.log("TERCERA OPCION", this.optimalWallet);
        console.log("TERCERA OPCION", !isActive);
        this.openDialog();
      }
    } else if (component == 'broker') {

      // ── 1. ¿Está /broker abierto en OTRA pestaña viva? ──────────────────
      if (await this.brokerTabLock.isHeldElsewhere()) {
        this.toastr.error('El broker ya está abierto en otra pestaña', 'Broker', { timeOut: 4000 });
        return;
      }

      // Ignorar la query: /broker?cuenta=X también cuenta como "ya estoy en /broker"
      const isActive = this.router.isActive('/broker', { paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });

      // ── 2. Ya estoy en /broker → mostrar formulario para cambiar de cuenta
      if (isActive) {
        this.abrirDialogoInicioSesion();

      // ── 3. No estoy en /broker, tengo cartera en memoria → entrar directo
      } else if (!isActive && Object.keys(this.BrokoptimalWallet).length > 0 && this.BrokoptimalWallet.nombre !== '') {
        this.router.navigate(['/broker']);

      // ── 4. No estoy en /broker, sin cartera en memoria ───────────────────
      } else if (!isActive) {
        const brokerConectado = localStorage.getItem('brokerConectado') === 'true';
        const brokerTipoBroker = localStorage.getItem('brokerTipoBroker') || '';

        if (brokerConectado) {
          // Para IBKR validar que la cookie de sesión no haya expirado
          const sesionValida = brokerTipoBroker === 'METAAPI'
            ? true
            : this.cookieService.check('auth_broker');

          if (sesionValida) {
            const ultimaCuenta = brokerTipoBroker === 'METAAPI'
              ? localStorage.getItem('meta_api_account_login') || ''
              : localStorage.getItem('ultima_cuenta_broker') || '';
            if (ultimaCuenta) {
              this.router.navigate(['/broker'], { queryParams: { cuenta: ultimaCuenta } });
            } else {
              this.router.navigate(['/broker']);
            }
          } else {
            // Cookie expirada → limpiar flag y pedir login
            localStorage.setItem('brokerConectado', 'false');
            window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: 'false' }));
            this.abrirDialogoInicioSesion();
          }
        } else {
          // Sin sesión activa → flujo normal de login
          this.abrirDialogoInicioSesion();
        }
      }
    }

  }


  currentDate: Date = new Date();
  formattedDate: any = this.datePipe.transform(
    this.currentDate,
    'dd MMMM yyyy'
  );
  irASeguimientoCarteras() {

    //this.router.navigate(["/seguimiento-carteras"]);
    const newTab = window.open("/seguimiento-carteras", '_blank');

  }
  version() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '180px',
      panelClass: this.theme,
      data: {
        msj: this.currentVersion
      }
    });
  }
 
  isActive(path: string): boolean {
    return this.router.isActive(path, true);
  }

  private showNotification(message: string, title: string) {
    this.notificacion = message;
    localStorage.setItem('currentNotification', JSON.stringify({
        message: message,
        title: title,
        timestamp: new Date().getTime()
    }));
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
      if (event.key === 'currentNotification' && event.newValue) {
          try {
              const notification = JSON.parse(event.newValue);
              if (notification && notification.message) {
                  this.notificacion = notification.message;
                  this.cd.detectChanges();
              }
          } catch (error) {
              console.error('Error parsing notification:', error);
          }
      }
  }
}
